<template>
<section>
<div class="container-fluid border-bottom" style="padding-left:0px;padding-right:0px;">
  <div id="myCarousel" class="carousel slide" data-bs-ride="carousel">
    <div class="carousel-indicators">
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="1" aria-label="Slide 2"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="2" aria-label="Slide 3"></button>
      <button type="button" data-bs-target="#myCarousel" data-bs-slide-to="3" aria-label="Slide 4"></button>
    </div>
    <div class="carousel-inner">
      <div class="carousel-item active" >
        <img src="@/assets/slider1.png" width="100%" height="100%" />

        <div class="container">
          <div class="carousel-caption text-start">
                            
          </div>
        </div>
      </div>
      <div class="carousel-item" >
        <img src="@/assets/slider2.png" width="100%" height="100%" />

        <div class="container">
          <div class="carousel-caption">
            
          </div>
        </div>
      </div>

      <div class="carousel-item" >
        <img src="@/assets/slider3.png" width="100%" height="100%" />

        <div class="container">
          <div class="carousel-caption text-end">
          </div>
        </div>
      </div>

      <div class="carousel-item" >
        <img src="@/assets/slider4.png" width="100%" height="100%" />

        <div class="container">
          <div class="carousel-caption text-end">
          </div>
        </div>
      </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Next</span>
    </button>
  </div>
</div>

<div id="certificate" class="container">
  <div id="mobile-certificate" class="row" style="margin-top:10px;">
    <div class="col-4 text-center">
      <img class="rounded-circle" width="60" height="60" src="@/assets/icon1.png" role="img" focusable="false" />
      <h6 class="mt-2">VHM & HACCP</h6>
      <p></p>
    </div>
    <div class="col-4 text-center">
      <img class="rounded-circle" width="60" height="60" src="@/assets/icon2.png" role="img" focusable="false" />
      <h6 class="mt-2">最佳燕窝产地</h6>
      <p></p>
    </div>
    <div class="col-4 text-center">
      <img class="rounded-circle" width="60" height="60" src="@/assets/icon3.png" role="img" focusable="false" />
      <h6 class="mt-2">完备的进口许可</h6>
      <p></p>
    </div>
  </div>

  <div id="desktop-certificate" class="row" style="margin-top:10px;">
    <div class="col-lg-4 text-center">
      <img class="rounded-circle" width="140" height="140" src="@/assets/icon1.png" role="img" focusable="false" />
      <h4>VHM & HACCP认证</h4>
      <p>我们的燕窝生产厂家具备合格的VHM和HACCP认证, 并遵循严格的加工流程</p>
    </div>
    <div class="col-lg-4 text-center" style="background:#ebe5e0;">
      <img class="rounded-circle" width="140" height="140" src="@/assets/icon2.png" role="img" focusable="false" />
      <h4>最佳燕窝产地</h4>
      <p>我们的燕窝产自马来西亚砂捞越(Sarawak)，世界公认的最佳燕窝产区</p>
    </div>
    <div class="col-lg-4 text-center">
      <img class="rounded-circle" width="140" height="140" src="@/assets/icon3.png" role="img" focusable="false" />
      <h4>完备的进口许可</h4>
      <p>每批燕窝均具备合格的进/出口许可证，健康证，等国家食品安全所规定的各类证明文件</p>
    </div>
  </div>
</div>
<div class="container mt-1">
    <div class="row" style="background:#ccccee;">
      <div class="col-md-7"  style="padding-top:10px; text-align:left;">
        <h4 class="featurette-heading">无畏时光 滋养美肌</h4>
        <p class="lead">燕窝的好评好处文章，媒体上随处可见，其高贵之处，价格可见一斑，古时是宫廷珍品，随后慢慢走进百姓家庭中来，特别这些年，随着经济复兴，
          人民生活水平的提高，健康及美颜的要求，从未象现在这般重视，推出质优价好的燕窝,正当时，应有其自身一席之地。特别在大统华推出,更显物真价实之感，
          让加拿大的消费者，特别是爱美的华人女性朋友，真正能享受到高品质的燕窝.
        </p>
        <p class="lead">除了加拿大政府对进口燕窝有明文要求之处，我公司对产品的加工厂和产品标准有更细仔的要求如下</p>
        <p class="lead">一、产品品牌</p>
        <p class="lead">御燕牌金丝燕窝 等级:5A干燕盏(包装:50克盒装), 保质期:常温3年，折封后,冷藏保疗</p>
        <p class="lead">二、成份</p>
        <p class="lead">100%原盏燕，不加任何防腐剂，漂白剂。同时燕窝酸(唾液酸)含量9.0%作保障</p>
      </div>
      <div class="col-md-5">
        <img src="@/assets/bnshow2.jpg" width="100%" />
      </div>
    </div>
</div>
<div class="container mt-2">
  <div class="row">
    <div class="col">
      <img src="@/assets/certificate.jpg" width="100%" />
    </div>
  </div>
</div>

<div class="container mt-2">
  <div class="card">
    <h5 class="card-header text-start text-success">大自然的馈赠 人与自然的和谐</h5>
    <div class="card-body">
      <h6 class="card-title text-start">您知道我们的燕窝是怎么来的吗？</h6>
      <p class="card-text text-start">
        <span id="article-summary" class="text-primary text-opacity-25">来自马来西亚的驰名品牌“御燕”的燕窝产自马来西亚砂捞越Sarawak），<a id="read-all" class="text-success" @click="readAll()">阅读全部 ... ...</a></span>
        <span id="article-rest" class="d-none">砂捞越坐落在世界闻名的婆罗洲热带雨林上，由于这里优越的大自然环境，被公认为世界最佳燕窝产区，燕种只选金丝燕，是世界上最好的产燕窝燕种，它们是婚姻的典范，夫妻恩爱有加 ，完全一夫一妻还终身制，相互关爱15-18年，为了繁延后代，燕夫妻需要约40天勤奋筑燕窝，坚固可靠，而后，燕夫妻从此开始下蛋孵化养育，整个过程约80天，所以，一对燕夫妻一年只能出产3只燕窝，少之甚少！除了品种和产地要求之外，我们对燕窝原料的品质的选择更是精益求精，只挑选乳白色或淡黄色，少毛的燕盏用于进一步的加工。我们的加工厂拥有马来西亚卫生部颁发的国际高标准HACCP食品安全体系认证、GMP优良加工标准体系认证，和马来西亚兽医局颁发的最高标准VHM体系认证，由马来西亚卫生部和兽医局共同监督，在产品质量上有着严格的保障。当原料进厂后，马上冷藏保存；再次检查原料质量，过关后，才进入下一工序—古法半干挑毛，加工过程只使用过滤可食用纯净水，绝不使用漂白剂，防腐剂，100%纯燕窝，燕窝酸含量保证在9%以上。每个娴熟工人一天只能生产出7-8只好燕窝，好燕窝的标准是干燕盏形态完整，呈现乳白色或淡黄色，燕丝根根可见，干净纯洁无杂质；严格烘干程序，确保完全符合马来西亚出口的标准以及加拿大进口标准的高品质燕窝产品，我们的“御燕”牌5A干燕盏是值得高端消费者们信赖的好产品，最后，我们承诺零售产品在常温和原封包袋下都能保存三年。不过，在拆开内包装时，一定要十分小心，因为我们燕窝含水率极低，所以十分干燥松脆，泡发蒸煮后增重比例超过二十倍，真是买到就是赚到了！再次感谢大自然的馈赠，感谢燕儿们！</span></p>
    </div>
  </div>
  <div class="card mt-2">
    <h5 class="card-header text-start text-success">顶级工艺缔造的燕窝传奇</h5>
    <div class="card-body">
      <p class="card-title text-start">加拿大<b class="c-red">三鱼公司</b> 联手 大马<b>御燕国际</b></p>
      <div class="container">
        <div class="row">
          <div class="col-4"><img src="@/assets/ywcq_1.jpg" width="100%" /></div>
          <div class="col-4"><img src="@/assets/ywcq_2.jpg" width="100%" /></div>
          <div class="col-4"><img src="@/assets/ywcq_3.jpg" width="100%" /></div>
        </div>
        <div class="row mt-2">
          <div class="col text-start" style="font-size:16px;">
            <ul style="list-style-type: circle;">
              <li>三鱼公司 经营理念 精选上乘 保证质量</li>
              <li>马来西亚是全球燕窝顶尖生产基地之一</li>
              <li>御燕国际 凭借独天得厚的地利优势</li>
              <li>通过天然采摘、精心工艺，层层筛选</li>
              <li>将生产天然燕窝的优势，发挥到极致</li>
              <li>缔造出蜚声世界的燕窝传奇</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</section>
</template>
<script>
  //import bulmaCarousel from 'bulma-carousel/dist/js/bulma-carousel.min.js'
  import {onMounted} from 'vue'
  import $ from 'jquery'
  export default {
    name: 'home',
    components: {},
    emits: ['viewLoaded'],
    setup(props,ctx) {
      onMounted(() => {
        ctx.emit('viewLoaded','home')
      })
      const readAll = () => {
        $('#article-summary').removeClass('text-primary');
        $('#read-all').addClass('d-none');
        $('#article-rest').removeClass('d-none')
      }

      return {readAll}
    }
  };
</script>
<style lang="scss" scoped>
.lead {font-size:16px !important;}
#certificate {
  padding-top: 10px;
  .col-lg-4 { padding-top: 10px;}
  h4 {margin-top:5px;}
  @media only screen and (min-width: 1024px) {
      #mobile-certificate {display:none;}
  }
  @media only screen and (max-width: 500px) {
      #desktop-certificate {display:none;}
  }
}

</style>
